import React from "react";
import { IconChevronRight } from "@tabler/icons-react";
import "./CreditUsage.scss";

function CreditUsage({ balance = 0, limit = 0, accounts = [], compact = false, onSeeAllClick }) {
  const percentage = limit > 0 ? Math.round((balance / limit) * 100) : 0;
  const fillWidth = limit > 0 ? (balance / limit) * 100 : 0;

  const formatCurrency = (amount) => {
    const numAmount = parseInt(amount) || 0;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numAmount);
  };

  const maskAccountNumber = (accNum) => {
    if (!accNum) return "****";
    const last4 = accNum.slice(-4);
    return `****${last4}`;
  };

  return (
    <div className={`credit-usage-container ${compact ? "compact" : ""}`}>
      <div className="credit-usage-header">
        <h3 className="credit-usage-title">Credit Usage</h3>
        <span className="accounts-badge">{accounts.length}</span>
      </div>

      <div className="credit-usage-bar-container">
        <div className="credit-usage-bar">
          <div
            className="credit-usage-bar-fill"
            style={{ width: `${fillWidth}%` }}
          />
        </div>

        <div className="credit-usage-details">
          <div className="credit-usage-balance">
            <span className="label">Balance</span>
            <span className="value">{formatCurrency(balance)}</span>
          </div>
          <div className="credit-usage-limit">
            <span className="label">Limit</span>
            <span className="value">{formatCurrency(limit)}</span>
            <span className="percentage-badge">{percentage}%</span>
          </div>
        </div>
      </div>

      {/* Accounts Table */}
      {accounts.length > 0 && (
        <div className={`accounts-table ${compact ? "compact" : ""}`}>
          <div className="table-header">
            <div className="col-name">Account</div>
            <div className="col-balance">Balance</div>
            {!compact && <div className="col-limit">Credit Limit</div>}
            {!compact && <div className="col-type">Type</div>}
          </div>
          <div className="table-body">
            {accounts.map((item) => (
              <div key={item.id} className="table-row">
                <div className="col-name">
                  <div className="account-icon">
                    {item.tradeline?.customerName?.charAt(0) || "?"}
                  </div>
                  <div className="account-info">
                    <span className="account-name">
                      {item.tradeline?.customerName || "Unknown"}
                    </span>
                    <span className="account-number">
                      {maskAccountNumber(item.tradeline?.accountNumber)}
                    </span>
                  </div>
                </div>
                <div className="col-balance">
                  {formatCurrency(item.tradeline?.balanceAmount || 0)}
                </div>
                {!compact && (
                  <div className="col-limit">
                    {item.tradeline?.creditLimitAmount
                      ? formatCurrency(item.tradeline?.creditLimitAmount)
                      : "N/A"}
                  </div>
                )}
                {!compact && (
                  <div className="col-type">
                    {item.tradeline?.accountTypeText || "Unknown"}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* See All Accounts Link */}
      {onSeeAllClick && (
        <div className="see-all-section">
          <button className="see-all-link" onClick={onSeeAllClick}>
            See All Accounts
            <IconChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
}

export default CreditUsage;
